import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchContactFormUnreadCount } from "../services/messagingService";
import { useAuth } from "./AuthContext";

const MessagingContext = createContext();

export const MessagingProvider = ({ children }) => {
    const { accessToken, role } = useAuth();
    const location = useLocation();

    const [unreadCount, setUnreadCount] = useState(0);
    const inFlightRef = useRef(false);

    const refreshUnreadCount = async () => {
        if (!accessToken) return;
        if (inFlightRef.current) return;

        inFlightRef.current = true;
        try {
            const data = await fetchContactFormUnreadCount();
            setUnreadCount(data.unread_count || 0);
        } catch (err) {
            console.error("Failed to refresh unread count");
        } finally {
            inFlightRef.current = false;
        }
    };

    useEffect(() => {
        if (!accessToken) return;
        if (!(role === "freelancer" || role === "business")) return;
        if (location.pathname.startsWith("/home/mailbox")) return;

        refreshUnreadCount();
    }, [location.pathname, accessToken, role]);

    return (
        <MessagingContext.Provider
            value={{
                unreadCount,
                setUnreadCount,
                refreshUnreadCount,
            }}
        >
            {children}
        </MessagingContext.Provider>
    );
};

export const useMessaging = () => useContext(MessagingContext);